(() => {
  const dialog = document.querySelector('[data-rec-my-rec]');
  if (!dialog) return;
  const closeButtons = dialog.querySelectorAll('[data-rec-my-rec-close]');
  const base = (dialog.dataset.accountUrl || '/account').replace(/\/+$/, '');
  let lastOpener = null;

  const routeUrl = (handle) => handle ? `${base}/${handle}` : base;

  dialog.querySelectorAll('[data-rec-account-route]').forEach((link) => {
    link.href = routeUrl(link.dataset.recAccountRoute || '');
  });

  const open = (opener) => {
    lastOpener = opener || document.activeElement;
    if (typeof dialog.showModal === 'function') dialog.showModal();
    else dialog.setAttribute('open', '');
    document.documentElement.classList.add('rec-my-rec-open');
    const closeButton = dialog.querySelector('[data-rec-my-rec-close]');
    if (closeButton) window.setTimeout(() => closeButton.focus({ preventScroll: true }), 30);
  };

  const close = () => {
    if (typeof dialog.close === 'function' && dialog.hasAttribute('open')) dialog.close();
    else dialog.removeAttribute('open');
    document.documentElement.classList.remove('rec-my-rec-open');
  };

  closeButtons.forEach((button) => button.addEventListener('click', close));
  dialog.addEventListener('click', (event) => { if (event.target === dialog) close(); });
  dialog.addEventListener('cancel', () => document.documentElement.classList.remove('rec-my-rec-open'));
  dialog.addEventListener('close', () => {
    document.documentElement.classList.remove('rec-my-rec-open');
    if (lastOpener && document.contains(lastOpener)) lastOpener.focus({ preventScroll: true });
  });

  const looksLikeAccount = (anchor) => {
    if (!anchor || dialog.contains(anchor)) return false;
    const href = anchor.getAttribute('href') || '';
    if (!href.includes('/account')) return false;
    return Boolean(anchor.closest('header, #shopify-section-header, .ftf-header, .ftf-toolbar, [class*="header"]'));
  };

  document.addEventListener('click', (event) => {
    if (event.defaultPrevented || event.button > 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    const anchor = event.target.closest('a[href]');
    if (!looksLikeAccount(anchor)) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    open(anchor);
  }, true);

  const labelAccountControls = () => {
    document.querySelectorAll('header a[href*="/account"], .ftf-toolbar a[href*="/account"]').forEach((anchor) => {
      if (dialog.contains(anchor)) return;
      anchor.setAttribute('aria-label', 'Open My REC account hub');
      anchor.setAttribute('title', 'MY REC');
    });
  };

  labelAccountControls();
  document.addEventListener('shopify:section:load', labelAccountControls);
})();